import { useQuery, gql } from '@zenbusiness/application-commons-graphql';
import jsonSoftParse from '@zenbusiness/application-commons-utils/jsonSoftParse';
import Alert from '@zenbusiness/zui/Alert';
import AlertTitle from '@zenbusiness/zui/AlertTitle';
import LinearProgress from '@zenbusiness/zui/LinearProgress';
import Paper from '@zenbusiness/zui/Paper';
import Text from '@zenbusiness/zui/Text';

import Hello from '#client/components/Hello';

export default function Account() {
  const {
    loading,
    error,
    data: { account = null } = {}
  } = useQuery(
    gql`
      query CurrentAccount {
        account {
          uuid
          email
          firstName
          lastName
          createdAt
        }
      }
    `,
    {
      noThrow: true
    }
  );

  if (loading) {
    return <LinearProgress />;
  }

  if (error) {
    const { fetchError, graphQLErrors, httpError } = error;

    if (fetchError) {
      throw fetchError;
    }
    if (graphQLErrors) {
      throw graphQLErrors[0];
    }
    if (httpError) {
      return (
        <Alert
          elevation={1}
          severity="error"
        >
          <AlertTitle>{`Server Error (${httpError.status} ${httpError.statusText}):`}</AlertTitle>
          {jsonSoftParse(httpError.body)?.errors?.map?.(({ message }) => message)}
        </Alert>
      );
    }
  }

  if (!account) {
    return (
      <Alert
        elevation={1}
        severity="warning"
      >
        Account is null!
      </Alert>
    );
  }

  return (
    account && (
      <>
        {Object.entries(account).map(([key, value]) => (
          <Paper key={key}>
            <Text>{String(key)}</Text>
            <Text>{String(value)}</Text>
          </Paper>
        ))}
        <Hello
          name={[account.firstName, account.lastName].join(' ')}
          sx={{ mt: '8px' }}
        />
      </>
    )
  );
}
